import type { PiniaPluginContext } from 'pinia';

/**
 * 枚举存储ID
 */
export enum SetupStoreId {
  Auth = 'auth',
  Route = 'route',
  App = 'app',
  Theme = 'theme',
  Tab = 'tab'
}

/**
 * 重置使用setup语法编写的store状态的插件
 *
 * @param context
 */
export function resetSetupStore(context: PiniaPluginContext) {
  const setupSyntaxIds = Object.values(SetupStoreId) as string[];

  if (setupSyntaxIds.includes(context.store.$id)) {
    const { $state } = context.store;

    const defaultStore = JSON.parse(JSON.stringify($state));

    context.store.$reset = () => {
      context.store.$patch(defaultStore);
    };
  }
} 